import { VitalMetric } from '../../types/health';
import { Wind, Droplets, Heart, Activity, Thermometer } from 'lucide-react';

export const vitalMetrics: VitalMetric[] = [
  {
    name: 'Respiratory Rate',
    value: '14.2',
    unit: 'rpm',
    iconName: 'Wind',
    status: 'normal',
    trend: 'stable',
    range: '12-16',
    baseline: 14.4
  },
  {
    name: 'Blood Oxygen',
    value: '98',
    unit: '%',
    iconName: 'Droplets',
    status: 'normal',
    trend: 'stable',
    range: '95-100',
    baseline: 98
  },
  {
    name: 'Resting HR',
    value: '54',
    unit: 'bpm',
    iconName: 'Heart',
    status: 'normal',
    trend: 'stable',
    range: '50-65',
    baseline: 56
  },
  {
    name: 'HRV',
    value: '68',
    unit: 'ms',
    iconName: 'Activity',
    status: 'normal',
    trend: 'stable',
    range: '45-65',
    baseline: 65
  },
  {
    name: 'Skin Temp',
    value: '+3.0',
    unit: '°F',
    iconName: 'Thermometer',
    status: 'warning',
    trend: 'up',
    range: '-2.0 to +2.0',
    baseline: -0.5
  }
];

export const healthIcons = {
  Wind,
  Droplets,
  Heart,
  Activity,
  Thermometer
};